var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.i18n !== undefined)?_c('div',{},[_c('ranch-button',{attrs:{"route":{ name: 'invoice.welcome', query: { credits: _vm.amount } },"label":_vm.i18n.action_label,"icon":"plus-circle"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }